import { Person } from '@/models/Person';

export enum SearchTypes {
    SEARCH_CHANGE = '@search/SEARCH_CHANGE',
    SEARCH_CLEAR = '@search/SEARCH_CLEAR',
    SEARCH_SUBMIT = '@search/SEARCH_SUBMIT',
    GET_SEARCH_HISTORY_REQUEST = '@search/GET_SEARCH_HISTORY_REQUEST',
    GET_SEARCH_HISTORY_SUCCESS = '@search/GET_SEARCH_HISTORY_SUCCESS',
    GET_SEARCH_HISTORY_FAILURE = '@search/GET_SEARCH_HISTORY_FAILURE',
    DELETE_SEARCH_HISTORY_REQUEST = '@search/DELETE_SEARCH_HISTORY_REQUEST',
    DELETE_SEARCH_HISTORY_SUCCESS = '@search/DELETE_SEARCH_HISTORY_SUCCESS',
    DELETE_SEARCH_HISTORY_FAILURE = '@search/DELETE_SEARCH_HISTORY_FAILURE',
    GET_SEARCH_SUGGESTIONS_REQUEST = '@search/GET_SEARCH_SUGGESTIONS_REQUEST',
    GET_SEARCH_SUGGESTIONS_SUCCESS = '@search/GET_SEARCH_SUGGESTIONS_SUCCESS',
    GET_SEARCH_SUGGESTIONS_FAILURE = '@search/GET_SEARCH_SUGGESTIONS_FAILURE',
    CLEAR_SUGGESTIONS_LIST = '@search/CLEAR_SUGGESTIONS_LIST',
}

export interface SearchState {
    data: Search;
    doSearch: boolean;
    loading: boolean;
    hasError: boolean;
}

export interface Search {
    term: string;
    lastTerm: string;
    history: SearchHistory[];
    suggestions: string[];
}

export interface SearchHistory {
    id: number;
    term: string;
    creationDate: Date;
    person: Person;
}
